var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ProductTile from './ProductTile';
import ProductTileSkeleton from './ProductTileSkeleton';
import useOnScreen from './useOnScreen';
import Icons from '../Icons/Icons';
import { isMobile } from '../../utils/utilities';
const closeIcon = (React.createElement("svg", { width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M13.5626 12.9997C13.6018 13.0362 13.6332 13.0802 13.655 13.129C13.6767 13.1779 13.6884 13.2307 13.6894 13.2842C13.6903 13.3377 13.6805 13.3908 13.6605 13.4404C13.6404 13.49 13.6106 13.5351 13.5728 13.5729C13.5349 13.6108 13.4899 13.6406 13.4402 13.6606C13.3906 13.6807 13.3375 13.6905 13.284 13.6896C13.2305 13.6886 13.1777 13.6769 13.1289 13.6551C13.08 13.6334 13.036 13.602 12.9995 13.5628L8.49983 9.0638L4.00014 13.5628C3.92461 13.6332 3.82471 13.6715 3.72149 13.6697C3.61826 13.6679 3.51978 13.6261 3.44678 13.5531C3.37378 13.4801 3.33196 13.3816 3.33014 13.2784C3.32832 13.1751 3.36663 13.0752 3.43701 12.9997L7.93604 8.50001L3.43701 4.00032C3.36663 3.92479 3.32832 3.82489 3.33014 3.72167C3.33196 3.61845 3.37378 3.51996 3.44678 3.44696C3.51978 3.37396 3.61826 3.33214 3.72149 3.33032C3.82471 3.3285 3.92461 3.36682 4.00014 3.4372L8.49983 7.93622L12.9995 3.4372C13.075 3.36682 13.1749 3.3285 13.2782 3.33032C13.3814 3.33214 13.4799 3.37396 13.5529 3.44696C13.6259 3.51996 13.6677 3.61845 13.6695 3.72167C13.6713 3.82489 13.633 3.92479 13.5626 4.00032L9.06362 8.50001L13.5626 12.9997Z", fill: "black" })));
const filterIcon = (React.createElement("svg", { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M3.4375 7.39065H6.41094C6.52928 7.97345 6.84547 8.49742 7.30593 8.87378C7.76639 9.25013 8.3428 9.45573 8.9375 9.45573C9.5322 9.45573 10.1086 9.25013 10.5691 8.87378C11.0295 8.49742 11.3457 7.97345 11.4641 7.39065H18.5625C18.6993 7.39065 18.8304 7.33632 18.9271 7.23962C19.0238 7.14292 19.0781 7.01177 19.0781 6.87502C19.0781 6.73827 19.0238 6.60712 18.9271 6.51042C18.8304 6.41372 18.6993 6.3594 18.5625 6.3594H11.4641C11.3457 5.77659 11.0295 5.25262 10.5691 4.87626C10.1086 4.49991 9.5322 4.29431 8.9375 4.29431C8.3428 4.29431 7.76639 4.49991 7.30593 4.87626C6.84547 5.25262 6.52928 5.77659 6.41094 6.3594H3.4375C3.30075 6.3594 3.1696 6.41372 3.0729 6.51042C2.9762 6.60712 2.92188 6.73827 2.92188 6.87502C2.92188 7.01177 2.9762 7.14292 3.0729 7.23962C3.1696 7.33632 3.30075 7.39065 3.4375 7.39065ZM8.9375 5.32815C9.24344 5.32815 9.54252 5.41887 9.7969 5.58884C10.0513 5.75881 10.2495 6.0004 10.3666 6.28306C10.4837 6.56571 10.5143 6.87674 10.4547 7.1768C10.395 7.47687 10.2476 7.75249 10.0313 7.96883C9.81497 8.18516 9.53934 8.33249 9.23928 8.39217C8.93922 8.45186 8.62819 8.42123 8.34554 8.30415C8.06288 8.18707 7.82129 7.9888 7.65132 7.73442C7.48135 7.48004 7.39062 7.18096 7.39062 6.87502C7.39062 6.46476 7.5536 6.07131 7.84369 5.78122C8.13379 5.49112 8.52724 5.32815 8.9375 5.32815ZM18.5625 14.6094H16.9641C16.8457 14.0266 16.5295 13.5026 16.0691 13.1263C15.6086 12.7499 15.0322 12.5443 14.4375 12.5443C13.8428 12.5443 13.2664 12.7499 12.8059 13.1263C12.3455 13.5026 12.0293 14.0266 11.9109 14.6094H3.4375C3.30075 14.6094 3.1696 14.6637 3.0729 14.7604C2.9762 14.8571 2.92188 14.9883 2.92188 15.125C2.92188 15.2618 2.9762 15.3929 3.0729 15.4896C3.1696 15.5863 3.30075 15.6406 3.4375 15.6406H11.9109C12.0293 16.2235 12.3455 16.7474 12.8059 17.1238C13.2664 17.5001 13.8428 17.7057 14.4375 17.7057C15.0322 17.7057 15.6086 17.5001 16.0691 17.1238C16.5295 16.7474 16.8457 16.2235 16.9641 15.6406H18.5625C18.6993 15.6406 18.8304 15.5863 18.9271 15.4896C19.0238 15.3929 19.0781 15.2618 19.0781 15.125C19.0781 14.9883 19.0238 14.8571 18.9271 14.7604C18.8304 14.6637 18.6993 14.6094 18.5625 14.6094ZM14.4375 16.6719C14.1316 16.6719 13.8325 16.5812 13.5781 16.4112C13.3237 16.2412 13.1255 15.9996 13.0084 15.717C12.8913 15.4343 12.8607 15.1233 12.9203 14.8232C12.98 14.5232 13.1274 14.2476 13.3437 14.0312C13.56 13.8149 13.8357 13.6676 14.1357 13.6079C14.4358 13.5482 14.7468 13.5788 15.0295 13.6959C15.3121 13.813 15.5537 14.0112 15.7237 14.2656C15.8937 14.52 15.9844 14.8191 15.9844 15.125C15.9844 15.5353 15.8214 15.9287 15.5313 16.2188C15.2412 16.5089 14.8478 16.6719 14.4375 16.6719Z", fill: "black" })));
const CollectionListing = ({ collectionHandle, collectionMenu, collectionFiltersEnabled }) => {
    const [products, setProducts] = useState([]);
    const [strings, setStrings] = useState(null);
    const [settings, setSettings] = useState(null);
    const [nextURL, setNextURL] = useState('');
    const [previousURL, setPreviousURL] = useState('');
    const [loadText, setLoadText] = useState('Loading products');
    const [loadingMore, setLoadingMore] = useState(false);
    const [disableLoadMore, setDisableLoadMore] = useState(false);
    const loadTrigger = useRef(null);
    const isOnScreen = useOnScreen(loadTrigger);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [filters, setFilters] = useState(null);
    const [activeFilters, setActiveFilters] = useState({});
    const [filtersCollapsed, setFiltersCollapsed] = useState([]);
    const [otherCollection, setOtherCollection] = useState(null);
    const [hideFilterButton, setHideFilterButton] = useState(false);
    const [accordionItems, setAccordionItems] = useState([]);
    const [accordionActive, setAccordionActive] = useState(-1);
    const [calloutData, setCalloutData] = useState(null);
    const loadInitProducts = () => {
        return axios
            .get(`/collections/${collectionHandle}?view=json-data`)
            .then((res) => __awaiter(void 0, void 0, void 0, function* () {
            return res.data;
        }))
            .then((productData) => {
            const availableProducts = productData.products.filter((product) => product.tags.indexOf('hidden') === -1);
            setProducts(availableProducts);
            setStrings(productData.strings);
            setSettings(productData.settings);
            let filters = productData.filters
                .map((filter) => {
                filter.values = filter.values.filter((value) => value.count > 0);
                return filter;
            })
                .filter((filter) => filter.values.length > 0);
            setFilters(filters);
            const dynamicAccordion = (productData.dynamic.accordion_items || '').replaceAll('&lt;', '<').replaceAll('&gt;', '>');
            const newElement = document.createElement('div');
            newElement.innerHTML = dynamicAccordion;
            let accordionItems = [];
            let accordionItemsTitles = newElement.querySelectorAll('.metafield-rich_text_field > h3');
            let accordionItemsContents = newElement.querySelectorAll('.metafield-rich_text_field > p:not(:empty)');
            accordionItemsTitles.forEach((title, index) => {
                accordionItems.push({ title: title.innerHTML, content: accordionItemsContents[index].innerHTML });
            });
            setAccordionItems(accordionItems);
            setCalloutData(productData.dynamic.callout);
            const dynamicSubtitle = document.querySelector('.collection-header__body');
            const dynamicTitle = document.querySelector('.collection-header__title');
            const dynamicBody = document.querySelector('.collection-header__caption');
            const dynamicTag = document.querySelector('.collection-header__tag');
            if (dynamicSubtitle)
                dynamicSubtitle.innerHTML = productData.dynamic.subtitle;
            if (dynamicTitle)
                dynamicTitle.innerHTML = productData.dynamic.title;
            if (dynamicBody)
                dynamicBody.innerHTML = productData.dynamic.body;
            if (dynamicTag) {
                dynamicTag.innerHTML = productData.dynamic.tag_text;
                dynamicTag.style.backgroundColor = productData.dynamic.tag_color;
            }
            let activeFilters = {};
            productData.filters.forEach((filter) => {
                activeFilters[filter.param_name] = filter.active;
            });
            if (productData.next !== '') {
                setNextURL(productData.next);
                setLoadText(productData.strings.loading_products);
            }
            else {
                setLoadText(productData.strings.all_products_loaded);
                setDisableLoadMore(true);
            }
        });
    };
    const loadFilteredProducts = (filters) => {
        let filterString = '';
        if (Object.keys(filters).length) {
            Object.keys(filters).map((filterKey) => {
                filters[filterKey].map((filterValue) => {
                    filterString += `&${filterKey}=${filterValue}`;
                });
            });
        }
        const collectionLink = otherCollection ? otherCollection : `/collections/${collectionHandle}`;
        return axios
            .get(`${collectionLink}?view=json-data${filterString}`)
            .then((res) => __awaiter(void 0, void 0, void 0, function* () {
            return res.data;
        }))
            .then((productData) => {
            const availableProducts = productData.products.filter((product) => product.tags.indexOf('hidden') === -1);
            setProducts(availableProducts);
            setStrings(productData.strings);
            setSettings(productData.settings);
            let filters = productData.filters
                .map((filter) => {
                filter.values = filter.values.filter((value) => value.count > 0);
                return filter;
            })
                .filter((filter) => filter.values.length > 0);
            setFilters(filters);
            let dynamicAccordion = (productData.dynamic.accordion_items || '').replaceAll('&lt;', '<').replaceAll('&gt;', '>');
            let newElement = document.createElement('div');
            newElement.innerHTML = dynamicAccordion;
            const accordionItems = [];
            const accordionItemsTitles = newElement.querySelectorAll('.metafield-rich_text_field > h3');
            const accordionItemsContents = newElement.querySelectorAll('.metafield-rich_text_field > p:not(:empty)');
            accordionItemsTitles.forEach((title, index) => {
                accordionItems.push({ title: title.innerHTML, content: accordionItemsContents[index].innerHTML });
            });
            setAccordionItems(accordionItems);
            setCalloutData(productData.dynamic.callout);
            const dynamicSubtitle = document.querySelector('.collection-header__body');
            const dynamicTitle = document.querySelector('.collection-header__title');
            const dynamicBody = document.querySelector('.collection-header__caption');
            const dynamicTag = document.querySelector('.collection-header__tag');
            if (dynamicSubtitle)
                dynamicSubtitle.innerHTML = productData.dynamic.subtitle;
            if (dynamicTitle)
                dynamicTitle.innerHTML = productData.dynamic.title;
            if (dynamicBody)
                dynamicBody.innerHTML = productData.dynamic.body;
            if (dynamicTag) {
                dynamicTag.innerHTML = productData.dynamic.tag_text;
                dynamicTag.style.backgroundColor = productData.dynamic.tag_color;
            }
            if (productData.next !== '') {
                setNextURL(productData.next);
                setLoadText(productData.strings.loading_products);
            }
            else {
                setLoadText(productData.strings.all_products_loaded);
                setDisableLoadMore(true);
            }
        });
    };
    const loadMoreProducts = () => {
        if (nextURL === previousURL || !!loadingMore || disableLoadMore) {
            return null;
        }
        setLoadingMore(true);
        return axios
            .get(nextURL)
            .then((res) => __awaiter(void 0, void 0, void 0, function* () {
            return res.data;
        }))
            .then((prodData) => __awaiter(void 0, void 0, void 0, function* () {
            const availableProducts = prodData.products.filter((product) => product.tags.indexOf('hidden') === -1);
            const combinedProducts = [...products, ...availableProducts];
            setProducts(combinedProducts);
            if (prodData.next !== '') {
                setNextURL(prodData.next);
                setPreviousURL(nextURL);
            }
            else {
                setLoadText(prodData.strings.all_products_loaded);
                setDisableLoadMore(true);
            }
            setLoadingMore(false);
        }))
            .catch(() => {
            setLoadingMore(false);
            setDisableLoadMore(true);
        });
    };
    const toggleFilters = () => {
        if (filtersOpen) {
            setFiltersOpen(false);
        }
        else {
            setFiltersOpen(true);
        }
    };
    const toggleFilterValue = (paramName, value) => {
        const newActiveFilters = Object.assign({}, activeFilters);
        if (!newActiveFilters[paramName]) {
            newActiveFilters[paramName] = [];
        }
        if (newActiveFilters[paramName].includes(value)) {
            newActiveFilters[paramName] = newActiveFilters[paramName].filter((filterValue) => filterValue !== value);
        }
        else {
            newActiveFilters[paramName].push(value);
        }
        setActiveFilters(newActiveFilters);
        loadFilteredProducts(newActiveFilters);
    };
    const clearFilters = () => {
        setActiveFilters({});
        //loadFilteredProducts(activeFilters);
    };
    const collectionLinkClick = (e, link) => {
        e.preventDefault();
        setActiveFilters({});
        setOtherCollection(link);
        setDisableLoadMore(false);
        return false;
    };
    const toggleFilterCollapsed = (filter) => {
        if (filtersCollapsed.includes(filter)) {
            setFiltersCollapsed(filtersCollapsed.filter((f) => f !== filter));
        }
        else {
            setFiltersCollapsed([...filtersCollapsed, filter]);
        }
    };
    const toggleFilterButtonHide = () => {
        console.log('scrolling');
        if (isMobile) {
            console.log('mobile');
            let footer = document.querySelector('.footer');
            console.log(footer.getBoundingClientRect().top, window.innerHeight);
            if (footer.getBoundingClientRect().top < window.innerHeight) {
                setHideFilterButton(true);
            }
            else {
                setHideFilterButton(false);
            }
        }
    };
    const accordionToggle = (i) => {
        setAccordionActive(i === accordionActive ? -1 : i);
    };
    useEffect(() => {
        loadInitProducts();
        window.addEventListener('scroll', toggleFilterButtonHide);
        setTimeout(() => {
            let collapsibleTabs = document.querySelectorAll('.collection__products--accordion .accordion');
            collapsibleTabs.forEach((collapsibleTab) => {
                collapsibleTab.style.setProperty('--tab-height', `${collapsibleTab.querySelector('.accordion-tab').scrollHeight}px`);
            });
        }, 2000);
        return () => {
            window.removeEventListener('scroll', toggleFilterButtonHide);
        };
    }, []);
    useEffect(() => {
        if (isOnScreen && !disableLoadMore) {
            loadMoreProducts();
        }
    }, [isOnScreen, disableLoadMore]);
    useEffect(() => {
        if (isOnScreen) {
            loadMoreProducts();
        }
    }, [isOnScreen]);
    useEffect(() => {
        const handleFocus = () => {
            if (isOnScreen && !disableLoadMore) {
                loadMoreProducts();
            }
        };
        window.addEventListener('focus', handleFocus);
        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, [isOnScreen, disableLoadMore]);
    useEffect(() => {
        if (otherCollection) {
            loadFilteredProducts(activeFilters);
            console.log(`Pushing state to /collections/${otherCollection}`);
            window.history.pushState(null, null, `${otherCollection}`);
        }
    }, [otherCollection]);
    useEffect(() => {
        loadFilteredProducts(activeFilters);
        let collapsibleTabs = document.querySelectorAll('.collection__products--accordion .accordion');
        collapsibleTabs.forEach((collapsibleTab) => {
            collapsibleTab.style.setProperty('--tab-height', `${collapsibleTab.querySelector('.accordion-tab').scrollHeight}px`);
        });
    }, [activeFilters]);
    useEffect(() => {
        if (isMobile) {
            document.documentElement.classList.toggle('no-scroll', filtersOpen);
        }
    }, [filtersOpen]);
    let calloutFound = false;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `collection__products--toolbar ${collectionFiltersEnabled ? '' : 'collection__products--toolbar--disabled'}` },
            React.createElement("div", { className: "collection__formulations" }, collectionMenu
                ? collectionMenu.map((menuItem, index) => {
                    let isActive = !otherCollection ? menuItem.active == true : menuItem.url == otherCollection;
                    return (React.createElement("a", { role: "button", "data-test": menuItem.url, className: `collection__formulation ${isActive ? 'collection__formulation--active' : ''}`, key: `collection-menu--${index}`, onClick: (e) => collectionLinkClick(e, menuItem.url) }, menuItem.title));
                })
                : null),
            React.createElement("div", { className: `collection__filters-toggle-container ${hideFilterButton ? 'collection__filters-toggle-container--hidden' : ''}`, onClick: toggleFilters },
                React.createElement("button", { className: "collection__filters-toggle", "aria-label": "Toggle filters" },
                    filtersOpen ? 'Hide Filters' : 'Show Filters',
                    filtersOpen ? closeIcon : filterIcon))),
        React.createElement("div", { className: "collection__products--main" },
            React.createElement("div", { className: `collection__filters  ${collectionFiltersEnabled ? '' : 'collection__filters--hidden'} ${filtersOpen ? 'collection__filters--open' : ''} ${hideFilterButton ? 'collection__filters--hidden' : ''}` },
                React.createElement("div", { className: "collection__filters--inner" },
                    React.createElement("div", { className: "collection__filters--header" },
                        React.createElement("button", { className: "collection__filters--clear", onClick: clearFilters, "aria-label": 'Clear all filters' }, "Clear Filters"),
                        React.createElement("button", { className: "collection__filters--close", onClick: toggleFilters, "aria-label": 'Close filters' }, closeIcon)),
                    React.createElement("div", { className: "collection__filters--list" }, filters
                        ? filters.map((filter, index) => (React.createElement("div", { className: "collection__filter", key: `collection-filter--${index}` },
                            React.createElement("h3", { className: `collection__filter--title`, onClick: () => toggleFilterCollapsed(filter.label) },
                                filter.label,
                                " ",
                                filtersCollapsed.includes(filter.label) ? React.createElement(Icons.Plus, null) : React.createElement(Icons.Minus, null)),
                            React.createElement("div", { className: `collection__filter--options ${filtersCollapsed.includes(filter.label) ? 'collection__filter--options--collapsed' : ''}` }, filter.values.map((value, index) => {
                                let isActive = value.active == true || (activeFilters[value.param] || []).includes(value.value);
                                return (React.createElement("div", { className: `collection__filter--option`, key: `collection-filter-option--${index}`, "data-value": value.value, onClick: () => toggleFilterValue(value.param, value.value) },
                                    React.createElement("input", { type: "checkbox", id: `filter-${filter.label}-${value.value}`, name: `filter-${filter.label}-${value.value}`, value: value.value, checked: isActive }),
                                    React.createElement("div", { className: `collection__filter--option__label` }, value.label)));
                            })))))
                        : null))),
            React.createElement("div", { className: `collection__products--inner container ${filtersOpen ? 'collection__products--inner--filters-open' : ''}` },
                products.length === 0 && (React.createElement("div", { className: "collection__products--empty" },
                    "No results matching filters",
                    React.createElement("a", { onClick: clearFilters, className: "collection__products--empty-clear" }, "Reset Filters"))),
                products ? (products.map((product, index) => {
                    if ((calloutData || {}).position - 1 === index && calloutData && !!calloutData.image) {
                        calloutFound = true;
                        return (React.createElement(React.Fragment, null,
                            React.createElement("a", { className: "collection__callout", href: calloutData.link, key: `collection-callout--${index}` },
                                React.createElement("div", { className: "collection__callout--inner" },
                                    React.createElement("img", { src: calloutData.image, alt: calloutData.link_title, className: "collection__callout--image" }),
                                    React.createElement("div", { className: "collection__callout--content" },
                                        calloutData.title && React.createElement("h3", { className: "collection__callout--title" }, calloutData.title),
                                        calloutData.description && React.createElement("p", { className: "collection__callout--description", dangerouslySetInnerHTML: { __html: calloutData.description } }),
                                        calloutData.link_title && (React.createElement("a", { className: "button collection__callout--link", href: calloutData.link }, calloutData.link_title))))),
                            React.createElement(ProductTile, { product: product, settings: settings, strings: strings, key: `collection-product--${product.id}--${index}` })));
                    }
                    return React.createElement(ProductTile, { product: product, settings: settings, strings: strings, key: `collection-product--${product.id}--${index}` });
                })) : (React.createElement(ProductTileSkeleton, null)),
                (products && products.length > 0 && !calloutFound && calloutData && !!calloutData.image) && (React.createElement("a", { className: "collection__callout", href: calloutData.link },
                    React.createElement("div", { className: "collection__callout--inner" },
                        React.createElement("img", { src: calloutData.image, alt: calloutData.link_title, className: "collection__callout--image" }),
                        React.createElement("div", { className: "collection__callout--content" },
                            calloutData.title && React.createElement("h3", { className: "collection__callout--title" }, calloutData.title),
                            calloutData.description && React.createElement("p", { className: "collection__callout--description", dangerouslySetInnerHTML: { __html: calloutData.description } }),
                            calloutData.link_title && (React.createElement("a", { className: "button collection__callout--link", href: calloutData.link }, calloutData.link_title)))))),
                React.createElement("div", { "data-collection-load-trigger": "", ref: loadTrigger }))),
        React.createElement("div", { id: "collection-products-accordion" }),
        React.createElement("div", { className: "collection__products--accordion" },
            React.createElement("div", { className: "accordion-section container" },
                React.createElement("div", { className: "accordion-section__inner" },
                    accordionItems.length > 0 && React.createElement("h3", { className: "accordion-section__title" }, "Frequently Asked Questions"),
                    accordionItems.map((item, index) => (React.createElement("div", { className: `accordion ${accordionActive == index ? 'accordion--active' : ''}`, key: `accordion-item--${index}`, onClick: () => accordionToggle(index) },
                        React.createElement("div", { className: "accordion-title" },
                            React.createElement("div", { className: "accordion-title__content" },
                                React.createElement("span", { className: "accordion-title__heading" }, item.title)),
                            React.createElement("div", { className: "accordion-title__plus" },
                                React.createElement(Icons.Plus, null)),
                            React.createElement("div", { className: "accordion-title__minus" },
                                React.createElement(Icons.Minus, null))),
                        React.createElement("div", { className: "accordion-tab" },
                            React.createElement("div", { className: "accordion-tab__inner", dangerouslySetInnerHTML: { __html: item.content } }))))))))));
};
export default CollectionListing;
